/**
 * 파일명 : com0107m.tsx
 * 설명 :  조직도 화면
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 * 1.0       2020-08-10   윤성수     최초작성
 *     
 */

/************************************************
 * Import 영역  
 ************************************************/
/*  React  */
import React from 'react';
import OrganizationChart from "@dabeng/react-orgchart";

/*  AntD  */
import { Layout } from 'antd';

/*  업무  */
import * as commonProxy from 'libs/CommonProxy';
import OrgChartNode from "components/orgChartNode";

/************************************************
 * 전역변수 영역
 ************************************************/
const Com0107m = () => {
    /************************************************
     * 화면 초기화 영역  
     ************************************************/
    /**
     * 기능 : state 초기 구조선언
     * 설명 : state 초기 구조선언
     */
    const [treeData, setTreeData] = React.useState([]);
    const [isExists, setIsExists] = React.useState(false);
    let tmp = 0;
    const [orgKey, setOrgKey] = React.useState<number>(0);
    const [contentHeight, setContentHeight] = React.useState<number>(window.innerHeight);

    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     */
    React.useEffect(() => {
        const headerHeight = 0;  // Header 높이
        setContentHeight(window.innerHeight - headerHeight);
        
        const handleResize = () => {
            setContentHeight(window.innerHeight - headerHeight);
            let tmpKey = ++tmp;
            tmp = tmpKey;
            setOrgKey(tmpKey);
        };

        fn_Search();

        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize); // cleanup
        };
    }, []);

    React.useEffect(() => {
        if (treeData) {
            setIsExists(true);
        }
    }, [treeData]);


    /* Render 변수 선언영역 */
    /* AntD */
    const { Content } = Layout;

    /**
     * 기능 : 검색조회
     * param : 
     */
    const fn_Search = () => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc({}, {
            txCd: 'TRCOMR0007',
            success: (responseData:any) => {
                setTreeData(responseData.orgTree[0]);
            },
        });
    };

    return (
        <Layout>
                <Content>
                {isExists ?
                    <div key={orgKey} style={{ height: contentHeight, display: 'flex', flexDirection: 'column', width : '100%', flex: '1 1 auto', overflowY: 'auto' }}>
                        <OrganizationChart
                            datasource={treeData} 
                            chartClass='myChart'
                            NodeTemplate={OrgChartNode}
                            pan={true}
                            zoom={true}
                        />
                    </div>
                    : null}
                        
                </Content>
            </Layout>
    );
};

export default Com0107m;

